import { motion } from 'framer-motion';

export const HorizontalLineChart: React.FC<{
  maxValue?: number;
  dataset: {
    id: string;
    label: string;
    data: { value: number; suffix?: string; color: string }[];
  }[];
}> = ({ dataset, maxValue = 100 }) => {
  return (
    <div className="flex w-full flex-col space-y-6 md:space-y-3">
      {dataset.map(({ data, id, label }, index) => (
        <div key={id} className="flex w-full flex-col space-y-3">
          <div className="flex items-end space-x-3">
            <span className="flex-1 leading-normal md:-translate-y-0.5">
              {label}
            </span>
            <span className="shrink-0 font-bold leading-normal md:text-[48px] md:leading-none">
              {data[0].value}
              {data[0].suffix || null}
            </span>
          </div>

          <motion.div
            className="relative flex h-1 w-full overflow-hidden rounded-sm bg-neutral-4/20"
            initial="hidden"
            viewport={{ once: true }}
            whileInView="visible"
          >
            <motion.div
              className="origin-left rounded-sm"
              style={{
                width: `${data[0].value * (100 / maxValue)}%`,
                background: data[0].color,
              }}
              transition={{
                ease: 'easeOut',
                duration: 0.4,
                delay: index * 0.1,
              }}
              variants={{
                hidden: { opacity: 0, scaleX: 0 },
                visible: { opacity: 1, scaleX: 1 },
              }}
            />
          </motion.div>
        </div>
      ))}
    </div>
  );
};
